class OutOfStockTracker {
  constructor() {
    // console.log('🔍 OutOfStockTracker: Initializing...');
    this.init();
    // Check initial variant state
    this.checkInitialVariant();
  }

  init() {
    // Initialize the _sqzl array if it doesn't exist
    window._sqzl = window._sqzl || [];
    // console.log('🔍 OutOfStockTracker: Initialized _sqzl array:', window._sqzl);

    // Listen for variant changes
    document.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
    // console.log('🔍 OutOfStockTracker: Added variant change listener');
  }

  checkInitialVariant() {
    // console.log('🔍 OutOfStockTracker: Checking initial variant state...');

    const product = this.getProductData();
    if (!product) {
      // console.warn('❌ OutOfStockTracker: No product data found for initial check');
      return;
    }

    // Get the currently selected variant
    const currentVariantId = this.getCurrentVariantId();
    // console.log('🔍 OutOfStockTracker: Current variant ID:', currentVariantId);

    if (!currentVariantId) {
      // console.log('ℹ️ OutOfStockTracker: No variant currently selected');
      return;
    }

    const currentVariant = product.variants.find((v) => v.id === currentVariantId);

    if (currentVariant) {
      // console.log('🔍 OutOfStockTracker: Initial variant:', currentVariant);
      if (!currentVariant.available) {
        // console.log('🔍 OutOfStockTracker: Initial variant is out of stock, tracking...');
        this.trackOutOfStock(currentVariant);
      } else {
        // console.log('🔍 OutOfStockTracker: Initial variant is in stock');
      }
    }
  }

  getCurrentVariantId() {
    // Try to get variant ID from URL first
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId) {
      return Number(variantId);
    }

    // Fallback to first variant if none selected
    const product = this.getProductData();
    return product?.variants?.[0]?.id;
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (variant && !variant.available) {
      // console.log('🔍 OutOfStockTracker: Variant is out of stock, tracking...');
      this.trackOutOfStock(variant);
    }
  }

  trackOutOfStock(variant) {
    const product = this.getProductData();
    if (!product) {
      return;
    }

    const customer = this.getCustomerData();
    // console.log('🔍 OutOfStockTracker: Customer data:', customer);

    const trackingData = {
      event: 'Out of stock',
      email: customer?.email || '',
      firstname: customer?.firstName || '',
      lastname: customer?.lastName || '',
      products: [
        {
          id: variant.sku || variant.id.toString(),
          language: document.documentElement.lang || 'en',
          name: product.title + (variant.title !== 'Default Title' ? ` - ${variant.title}` : ''),
          price: variant.price / 100,
          quantity: 0,
        },
      ],
    };

    window._sqzl.push(trackingData);
  }

  getProductData() {
    const productJson = document.getElementById('ProductJson-' + this.getProductId());
    if (!productJson) {
      // console.warn('❌ OutOfStockTracker: Product JSON element not found');
      return null;
    }

    try {
      const data = JSON.parse(productJson.textContent);
      // console.log('🔍 OutOfStockTracker: Product data:', data);
      return data;
    } catch (e) {
      // console.error('❌ OutOfStockTracker: Error parsing product JSON:', e);
      return null;
    }
  }

  getCustomerData() {
    const customerJson = document.getElementById('CustomerJson-' + this.getProductId());
    if (!customerJson) {
      // console.log('ℹ️ OutOfStockTracker: No customer data found (user might not be logged in)');
      return null;
    }

    try {
      return JSON.parse(customerJson.textContent);
    } catch (e) {
      // console.error('❌ OutOfStockTracker: Error parsing customer JSON:', e);
      return null;
    }
  }

  getProductId() {
    const productJson = document.querySelector('[id^="ProductJson-"]');
    if (!productJson) {
      // console.warn('❌ OutOfStockTracker: No ProductJson element found');
      return '';
    }
    const id = productJson.id.replace('ProductJson-', '');
    // console.log('🔍 OutOfStockTracker: Product ID:', id);
    return id;
  }
}

// Initialize the tracker
customElements.define(
  'out-of-stock-tracker',
  class extends HTMLElement {
    connectedCallback() {
      // console.log('🔍 OutOfStockTracker: Custom element connected');
      new OutOfStockTracker();
    }
  }
);
